import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex)

var vueLocal = new VuexPersistence({
	storage: window.sessionStorage
})

const store = new Vuex.Store({
	modules: {
		app,
		user
	},
	getters,
	plugins: [vueLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js